export default __webpack_public_path__ + "img/c69429aca07b8ce4f3c3fc16bdd6972d.jpeg";